import axios from "axios";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import './MyStyles.css';

import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import AlarmIcon from "@mui/icons-material/Alarm";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from '../context/AuthContext';

import { baseUrl, userLocation, ipAddress, userName } from './Univ.js';

const formatDateTime = (dateTimeString) => {
  return new Date(dateTimeString).toLocaleString('en-IN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

function Header(props) {
  const [searchString, setsearchString] = useState({ search: '' });
  const { logoutUser } = useAuth();

  const checkUser = localStorage.getItem('user_login');
  const userGroup = localStorage.getItem('userGroup');

  const [tasks, setTasks] = useState([]);
  const [unreadTasks, setUnreadTasks] = useState([]);
  const [activities, setActivities] = useState([]);
  const [reminderTasks, setReminderTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (checkUser === 'true') {
      fetchActivities();
      fetchTasks();
    }
  }, [checkUser]);

  const fetchActivities = () => {
    setIsLoading(true);
    axios
      .get(`${baseUrl}activities/`)
      .then((res) => setActivities(res.data))
      .catch((err) => console.error(err))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];

    const filtered = activities.filter((row) => {
      if (!row.reminder_date) return false;
      const reminderDate = new Date(row.reminder_date).toISOString().split("T")[0];
      return reminderDate === today && row.addedby === userName;
    });

    setReminderTasks(filtered);
  }, [activities]);

  const countReminders = reminderTasks.length;
  const reminderBadgeColor = countReminders > 0 ? "warning" : "default";
  const reminderIconColor = countReminders > 0 ? "error" : "action";

  const fetchTasks = async () => {
    try {
      const response = await axios.get(baseUrl + "get-todo/");
      setTasks(response.data);
    } catch (error) {
      console.error('Error fetching tasks:', error);
    }
  };

  useEffect(() => {
    setUnreadTasks(tasks.filter(row => row.status === 1 && row.addedby === userName));
  }, [tasks]);

  const countUnreadTasks = unreadTasks.length;

  const handleLogout = () => {
    logoutUser();
    window.location.href = '/user-login/';
  };

  const linkMap = {
    Accounting: { home: '/account-menu/', menu: '/admin-menu' },
    Admin: { home: '/admin-menu', menu: '/' },
    Hr: { home: '/hrms-menu/', menu: '/admin-menu' },
    Stores: { home: '/stores-menu/', menu: '/admin-menu' },
    Manufacturing: { home: '/manufacturing-menu/', menu: '/admin-menu' },
  };

  const links = linkMap[userGroup] || {};

  return (
    <nav className="navbar navbar-expand-lg navbar-dark custom-navbar">
      <div className="container">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
          {checkUser === 'true' && (
            <>
              <Link className="navbar-brand" to={links.menu}>MGM ERP</Link>

              <ul className="navbar-nav ms-auto d-flex align-items-center">

                <li className="nav-item">
                  <Link className="navbar-brand" to={links.home}>
                    <FontAwesomeIcon icon="fa-solid fa-house-user" size="1x" color="#ffc107" />
                  </Link>
                </li>

                <li className="nav-item">
                  <Badge color={countUnreadTasks > 0 ? "warning" : "default"} badgeContent={countUnreadTasks}>
                    <a href="/todolist">
                      <MailIcon color={countUnreadTasks > 0 ? "error" : "action"} />
                    </a>
                  </Badge>
                </li>

                <li className="nav-item">
                  <Badge color={reminderBadgeColor} badgeContent={countReminders}>
                    <a href="/lead-list">
                      <AlarmIcon color={reminderIconColor} />
                    </a>
                  </Badge>
                </li>

                {/* USER DROPDOWN */}
<li className="nav-item dropdown">
  <a
    className="nav-link dropdown-toggle"
    href="#"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    {userName}
  </a>

  <ul className="dropdown-menu dropdown-menu-end">
    <li className="dropdown-item">Welcome: {userName}</li>

    <li>
      <Link className="dropdown-item" to="/admin-menu">
        Menu
      </Link>
    </li>

    <li>
      <Link className="dropdown-item" to="/change-password">
        Change Password
      </Link>
    </li>

    <li>
      <button className="dropdown-item" onClick={handleLogout}>
        Logout
      </button>
    </li>
  </ul>
</li>

              </ul>
            </>
          )}

        </div>
      </div>
    </nav>
  );
}

export { formatDateTime };
export default Header;
